import React, { useState, useEffect } from "react";
import { FaRegCheckCircle } from "react-icons/fa";

import "./ai-packages.css";

const AiPackages = () => {
  const sectionScrollHandler = (sectionId) => {
    const section = document.getElementById(sectionId);

    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };

  const checkResponsive = () => {
    if (window.innerWidth < 450) {
      return false;
    } else if (window.innerWidth > 450) {
      return true;
    }
  };

  const [activeBtn, setActiveBtn] = useState("chatbot_btn");
  //   const [showForm, setShowForm] = useState(false); // State to toggle form modal visibility

  //   const toggleFormModal = () => {
  //     setShowForm(!showForm);
  //   };

  const AiPackages = {
    chatbot_btn: {
      heading: "AI Chatbot",
      Pricing: "1000$ /month",
      description:
        "Engage your clients 24/7 with a smart AI Chatbot that communicates naturally via WhatsApp, providing instant responses, personalized follow-ups, and ensuring no leads are ever missed.",
      points: [
        "Engages leads instantly & 24/7, ensuring no queries go unanswered.",
        "Understands and responds in a natural, human-like manner.",
        "Follows up with clients automatically, increasing conversion rates.",
      ],
    },
    voicebot_btn: {
      heading: "AI Voicebot",
      Pricing: "2000$ /month",
      description:
        "Automate client calls with our AI Voice Bot, which answers inquiries, provides real-time solutions, and ensures consistent and professional communication as if it’s your own team member.",
      points: [
        "Handles calls autonomously, providing instant, accurate answers.",
        "Works as a virtual team member, ensuring consistent, professional interactions.",
        "Reduces human workload, allowing businesses to focus on strategic growth.",
      ],
    },
    erp_btn: {
      heading: "AI ERP Assistant",
      Pricing: "2500$ /month",
      description:
        "Simplify operations with our AI ERP Assistant, enabling voice-command actions, instant data retrieval, and automated workflows, saving time and reducing errors.",
      points: [
        "Enables voice-activated ERP commands, allowing seamless operations.",
        "Retrieves data instantly, eliminating delays in decision-making.",
        "Automates workflows, saving time & reducing errors in operations.",
      ],
    },
  };

  return (
    <section id="ai_packages_section">
      <div id="ai_packages_txt_div">
        <span>
          <h3 id="ai_packages_hdng">Tailored AI Assistant Modules</h3>
          <p id="ai_packages_txt">
            Choose the perfect AI-Assistant Module to streamline your
            operations, enhance customer engagement, and drive more sales.
          </p>
        </span>
        <button
          id="ai_learn_btn"
          onClick={() => {
            sectionScrollHandler("form_section");
          }}
        >
          Get Details
        </button>
      </div>

      <div id="ai_packages_content_div">
        <div id="ai_modules_div">
          <h3 id="ai_modules_hdng">AI Assistant Modules</h3>
          <div id="selection_btns_div">
            <button
              className={`selection_btn ${
                activeBtn === "chatbot_btn" ? "selected" : ""
              }`}
              id="chatbot_btn"
              onClick={() => setActiveBtn("chatbot_btn")}
            >
              AI Chatbot
            </button>
            <button
              className={`selection_btn ${
                activeBtn === "voicebot_btn" ? "selected" : ""
              }`}
              id="voicebot_btn"
              onClick={() => setActiveBtn("voicebot_btn")}
            >
              AI Voicebot
            </button>
            <button
              className={`selection_btn ${
                activeBtn === "erp_btn" ? "selected" : ""
              }`}
              id="erp_btn"
              onClick={() => setActiveBtn("erp_btn")}
            >
              AI ERP Assistant
            </button>
          </div>
        </div>

        <div id="ai_packages_details_div">
          <h3 className="ai_pkg_hdng">{AiPackages[activeBtn].heading}</h3>
          <p className="ai_pkg_price" id="goals_txt">
            {AiPackages[activeBtn].Pricing}
          </p>

          <p className="ai_pkg_txt" id="pains_txt">
            {AiPackages[activeBtn].description}
          </p>

          <span>
            <p className="ai_pkg_txt">
              <FaRegCheckCircle className="icon" />{" "}
              {AiPackages[activeBtn].points[0]}
            </p>
            <p className="ai_pkg_txt">
              <FaRegCheckCircle className="icon" />{" "}
              {AiPackages[activeBtn].points[1]}
            </p>
            <p className="ai_pkg_txt">
              <FaRegCheckCircle className="icon" />{" "}
              {AiPackages[activeBtn].points[2]}
            </p>
          </span>
        </div>
      </div>
    </section>
  );
};

export default AiPackages;
